import {possibleEvaluationsAnswers, possibleQuestionAnswers} from "@constants/common";

let effectiveness = {
    computed:{
        effectivenessHelper(){
            return {
                answerIcon:(answer)=>{
                    if(typeof answer === 'object'){
                        if (Array.isArray(answer) && answer.length >= 1
                            && 'action' in answer[0] && 'value' in answer[0].action) {
                            answer = answer[0].action.value;
                        } else if ('answer' in answer) {
                            answer = answer.answer;
                        } else {
                            answer = null;
                        }
                    }

                    switch (answer) {
                        case possibleQuestionAnswers.yes:
                        case possibleEvaluationsAnswers.yes:
                            return 'e-icon-effectiveness-yes'
                        case possibleEvaluationsAnswers.inProgress:
                            return 'e-icon-effectiveness-inprogress'
                        case possibleQuestionAnswers.maybe:
                            return 'e-icon-effectiveness-maybe'
                        case possibleQuestionAnswers.no:
                        case possibleEvaluationsAnswers.no:
                            return  'e-icon-effectiveness-no'
                        default:
                            return false;
                    }
                },
                sectionIcon:(answers)=>{
                    let icon = false;
                    let flattenAnswers = this.$lodash.flattenDeep(answers);
                    flattenAnswers.some((item)=>{
                        if(typeof item === 'object'){
                            item = item.val
                        }
                        if(item === possibleQuestionAnswers.no){
                            icon = 'e-icon-effectiveness-no';
                            return true;
                        } else if(item === possibleQuestionAnswers.maybe){
                            icon = 'e-icon-effectiveness-maybe';
                            return true;
                        }
                    });
                    return icon;
                }
            }
        }
    }
};

export default effectiveness;
